package com.hyperether.goodjob.repository.remote.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class JobIdRequest(
    @SerialName("jobId") var jobId: String? = null
)